export const formatConfidencePercent = (confidence: number) => {
    const fixedPercent = confidence.toFixed(1);

    return `${fixedPercent}%`;
};
